import Modal from 'react-modal';
import React from 'react';
import './ModalCommon.css'

const ProfileModal = ({ isOpen, onRequestClose, data }) => {

    React.useEffect(() => {
        const body = document.querySelector('body');
        if (isOpen) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'auto';
        }
    }, [isOpen]);

    function createContentArea(pContent) {
        if ('area-title' in pContent) {
            return (<div>
                <div className='line'></div>
                <div className='info-container'>

                    <div className='default-text' style={{ width: '115px' }}>{pContent['area-title']}</div>
                    <ul style={{ width: '100%' }}>
                        {pContent['content'].map((item, index) => (<div>
                            {(index !== 0) ? <div className='no-arrow-line' key={item.id}></div> : null}
                            <div className='no-arrow default-text'>{item['title']}</div>
                            {item['content'].map((innerItem, index) => (
                                <li key={index} className='default-text grey-text'>{innerItem}</li>
                            ))}
                        </div>
                        ))}
                    </ul>
                </div>
            </div>)
        }
        else {
            return (<div>
                <div className='line'></div>
                <div className='info-container'>
                    <div className='default-text' style={{ width: '115px'}}>{pContent['title']}</div>
                    <ul style={{ width: '100%' }}>
                        {pContent['content'].map((item, index) => (
                            <li key={index} className='default-text grey-text'>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>)
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            shouldReturnFocusAfterClose={true}
            className='common-modal-content'
            overlayClassName='common-modal-overlay'
        >
            <div className='center-div' style={{ paddingTop: '10%', paddingBottom: '10%',userSelect: 'none' }}>
                <img src={data["file-name"]} alt='' style={{width:'450px'}}></img>
            </div>
            <div style={{ paddingLeft: '1%' }}>
                <div className='default-text-bigger-2'>{data["name"]}</div>
                <span className='default-text grey-text'>{data["id"].join(' ')}</span>
                <div style={{ height: '20px' }}></div>
                <div className='default-text-bolder'>"{data["one-liner"]}"</div>
                <div className='default-text-bolder'>{data["intro"]}</div>
                <div style={{ height: '50px' }}></div>
                {data['info'].map((item, index) => (
                    createContentArea(item)
                ))}
                <div className='line'></div>
            </div>
            <div style={{ height: '50px' }}></div>
        </Modal>
    );
};

export default ProfileModal;
